import { render } from "./AvatarLetter.vue?vue&type=template&id=27de9021"
import script from "./AvatarLetter.vue?vue&type=script&lang=js"
export * from "./AvatarLetter.vue?vue&type=script&lang=js"

import "./AvatarLetter.vue?vue&type=style&index=0&id=27de9021&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__